import { MIN_CALIFICACIONES_REPUTACION_VISIBLE, reputacionListaActiva } from '../reputation/reputacionVendedor.js';
import { escapeHtml as esc } from './escapeHtml.js';

function starFilled(cls) {
  return `<svg class="${cls}" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>`;
}

function starEmpty(cls) {
  return `<svg class="${cls}" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.35" aria-hidden="true"><path stroke-linejoin="round" d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>`;
}

/**
 * Badge sobre la foto del card (listado catálogo).
 * @param {{ promedio?: number, cantidad?: number, minActivas?: number }} opts
 */
export function htmlBadgeEstrellasReputacion(opts = {}) {
  const min = opts.minActivas ?? MIN_CALIFICACIONES_REPUTACION_VISIBLE;
  const cantidad = Math.max(0, Math.floor(Number(opts.cantidad) || 0));
  const promedio = Math.min(5, Math.max(0, Number(opts.promedio) || 0));
  const activa = reputacionListaActiva(cantidad) && promedio > 0;
  const llenas = activa ? Math.min(5, Math.round(promedio)) : 0;
  const title = activa
    ? `Reputación: ${promedio.toFixed(1)} de 5 · ${cantidad} calificaciones`
    : `Reputación: se muestra con estrellas cuando el vendedor tenga al menos ${min} calificaciones`;
  const stars = Array.from({ length: 5 }, (_, i) => {
    const filled = i < llenas;
    const cls = filled
      ? 'h-3 w-3 text-amber-400 drop-shadow-sm'
      : activa
        ? 'h-3 w-3 text-white/35'
        : 'h-3 w-3 text-white/45';
    return filled ? starFilled(cls) : starEmpty(cls);
  }).join('');
  return `<span class="absolute bottom-2 left-2 flex items-center gap-0.5 rounded-md bg-black/55 px-1.5 py-0.5 backdrop-blur-sm" title="${esc(title)}">${stars}</span>`;
}

/** Bloque en ficha de producto (fondo claro). */
export function htmlFilaEstrellasReputacionDetalle(opts = {}) {
  const min = opts.minActivas ?? MIN_CALIFICACIONES_REPUTACION_VISIBLE;
  const cantidad = Math.max(0, Math.floor(Number(opts.cantidad) || 0));
  const promedio = Math.min(5, Math.max(0, Number(opts.promedio) || 0));
  const activa = reputacionListaActiva(cantidad) && promedio > 0;
  const llenas = activa ? Math.min(5, Math.round(promedio)) : 0;
  const stars = Array.from({ length: 5 }, (_, i) => {
    const filled = i < llenas;
    const cls = filled
      ? 'h-3.5 w-3.5 text-amber-500'
      : activa
        ? 'h-3.5 w-3.5 text-slate-300'
        : 'h-3.5 w-3.5 text-slate-300';
    return filled ? starFilled(cls) : starEmpty(cls);
  }).join('');
  const sub = activa
    ? `${promedio.toFixed(1)} · ${cantidad} calif.`
    : `Las estrellas se activan con ${min}+ calificaciones de compradores`;
  return `<div class="mt-1 flex flex-wrap items-center gap-2" title="${esc(
    activa ? `Reputación ${promedio.toFixed(1)} de 5` : 'Reputación del vendedor'
  )}"><span class="flex items-center gap-0.5">${stars}</span><span class="text-[11px] text-slate-500">${esc(sub)}</span></div>`;
}
